export default __webpack_public_path__ + "static/media/butterfly valve.8329f469.jpeg";